import React from 'react';
import { MessageSquareIcon, StarIcon, UsersIcon } from 'lucide-react';
import { socialProof, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-label="Testimonios de dueños" className="bg-forest-950 px-5 py-6 sm:py-10" data-id="element-264" data-mp="3fznsli0714zs">
      <div className="mx-auto max-w-6xl" data-id="element-265" data-mp="3b0kobzs1f2sv">
        <div className="flex flex-col items-center gap-2.5 rounded-2xl bg-forest-900 px-4 py-3 ring-1 ring-inset ring-gold-400/20 sm:flex-row sm:justify-between sm:gap-6 sm:px-7 sm:py-4" data-id="element-266" data-mp="3azje1xiuikc7">
          <p className="text-center font-display text-base leading-tight text-cream-50 sm:text-left sm:text-xl" style={{
          fontWeight: 700
        }} data-id="element-267" data-mp="31zms43nubzku">
            Más de <span className="text-gold-400" data-id="element-268" data-mp="2s28dm9lh9kv6">{socialProof.lectores} lectores</span> ya lo aplicaron
          </p>

          <dl className="flex w-full items-stretch gap-px overflow-hidden rounded-lg bg-cream-50/10 ring-1 ring-inset ring-cream-50/10 sm:w-auto" data-id="element-269" data-mp="v9ooxkq6li2z">
            <div className="flex-1 bg-forest-900 px-3 py-1.5 text-center sm:px-4" data-id="element-270" data-mp="q892ppc9p5j0">
              <dt className="sr-only" data-id="element-271" data-mp="h4dewra7py6t">Calificación</dt>
              <dd data-id="element-272" data-mp="m5kkqkssonau">
                <span className="flex items-center justify-center gap-1" data-id="element-273" data-mp="m62o01dvk1s9">
                  <span className="font-display text-sm text-cream-50 sm:text-base" style={{
                  fontWeight: 700
                }} data-id="element-274" data-mp="78abli3mjtia">
                    {socialProof.rating}
                  </span>
                  <span className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-275" data-mp="zwfx472i5mj6">
                    {Array.from({
                    length: 5
                  }).map((_, index) => <StarIcon key={index} className="h-2 w-2 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-276" data-mp="14u7o8yvbp4mb" data-mpi={index} />)}
                  </span>
                </span>
                <span className="block text-[0.55rem] uppercase tracking-wider text-cream-200/60" data-id="element-277" data-mp="v4xwxl8azpz9">Promedio</span>
              </dd>
            </div>

            <div className="flex-1 bg-forest-900 px-3 py-1.5 text-center sm:px-4" data-id="element-278" data-mp="1it7c44b0hfhf">
              <dt className="sr-only" data-id="element-279" data-mp="1nnlfasvx0qwn">Satisfacción</dt>
              <dd data-id="element-280" data-mp="1xiirqu67zghn">
                <span className="flex items-center justify-center gap-1 font-display text-sm text-cream-50 sm:text-base" style={{
                fontWeight: 700
              }} data-id="element-281" data-mp="1xgxzjb7do9my">
                  <UsersIcon className="h-2.5 w-2.5 text-gold-400" aria-hidden="true" data-id="element-282" data-mp="1ofzs0ixqdjzm" />
                  {socialProof.satisfaccion}
                </span>
                <span className="block text-[0.55rem] uppercase tracking-wider text-cream-200/60" data-id="element-283" data-mp="1ej4vg5l0ptnz">
                  Satisfacción
                </span>
              </dd>
            </div>

            <div className="flex-1 bg-forest-900 px-3 py-1.5 text-center sm:px-4" data-id="element-284" data-mp="19qlgp5algshl">
              <dt className="sr-only" data-id="element-285" data-mp="14r8veozdfth4">Reseñas</dt>
              <dd data-id="element-286" data-mp="10sja8a83d7mx">
                <span className="flex items-center justify-center gap-1 font-display text-sm text-cream-50 sm:text-base" style={{
                fontWeight: 700
              }} data-id="element-287" data-mp="10t1dhqt68m4c">
                  <MessageSquareIcon className="h-2.5 w-2.5 text-gold-400" aria-hidden="true" data-id="element-288" data-mp="quvh1oq4w86v" />
                  {socialProof.resenas}
                </span>
                <span className="block text-[0.55rem] uppercase tracking-wider text-cream-200/60" data-id="element-289" data-mp="37fqohlny28yn">Reseñas</span>
              </dd>
            </div>
          </dl>
        </div>

        {/* Reseñas en cuadraditos compactos */}
        <ul className="mt-3 grid grid-cols-2 gap-2 sm:mt-4 sm:grid-cols-4 lg:grid-cols-5" data-id="element-290" data-mp="3gfnh1ydgfryz">
          {testimonials.map(testimonial => {
          const [city] = testimonial.location.split(' — ');
          return <li key={testimonial.name} className="flex aspect-square flex-col rounded-lg bg-forest-900 p-2.5 ring-1 ring-inset ring-cream-50/10 transition-colors duration-150 ease-out hover:bg-forest-800" data-id="element-291" data-mp="2oq0x78je45bh">
                <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-292" data-mp="210gbwizrkvz1">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-2 w-2 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-293" data-mp="24zp3bh7c0hrf" data-mpi={index} />)}
                </div>
                <blockquote className="mt-1.5 line-clamp-5 text-[0.7rem] leading-snug text-cream-100" data-id="element-294" data-mp="1gyby6qtdtr8u">
                  “{testimonial.quote}”
                </blockquote>
                <footer className="mt-auto flex items-center gap-1.5 pt-2" data-id="element-295" data-mp="1vojb6r0mei25">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-400/20 font-display text-[0.55rem] text-gold-300" style={{
                fontWeight: 700
              }} data-id="element-296" data-mp="1quot1s0nyb56">
                    {testimonial.name.charAt(0)}
                  </span>
                  <span className="min-w-0" data-id="element-297" data-mp="2ej7ylzsbw9tk">
                    <span className="block truncate text-[0.65rem] font-semibold leading-tight text-cream-50" data-id="element-298" data-mp="29nixhs0nukv5">
                      {testimonial.name}
                    </span>
                    <span className="block truncate text-[0.55rem] leading-tight text-cream-200/60" data-id="element-299" data-mp="f8zuloc7ifcl">{city}</span>
                  </span>
                </footer>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}